import { render, staticRenderFns } from "./div-pagination.vue?vue&type=template&id=49073cc0&scoped=true&"
import script from "./div-pagination.vue?vue&type=script&lang=js&"
export * from "./div-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49073cc0",
  null
  
)

export default component.exports